<template>
  <ts-collapse
    externClass="seat-rights-select-group"
    expand="{{hasSeatSelected && !hasRightsChoosed}}"
    refreshTrigger="{{refreshTrigger}}"
    fadeDuration="{{0.5}}"
  >
    <seat-rights-select-card
      ref="card{{item?.type}}"
      wx:for="{{rightsInfo}}"
      serviceInfo="{{item}}"
      seatInfo="{{selectSeatInfo}}"
      bindclick="seatInfoClickReport"
      bindopenRightsDescDrawer="openRightsDescDrawer"
      bindshowBaichuanPrivacyDrawer="showBaichuanPrivacyDrawer"
    />
  </ts-collapse>
  <Privacy
    wx:if="{{showPrivacy}}"
    list="{{baichuanTrainPrivacy}}"
    bind:privacyVerify="privacyVerify"
  />
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { innerRouter, pagePath } from '@/common/jump'

  createComponent({
    props: {
      hasRightsChoosed: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        showPrivacy: false,
        refreshTrigger: true
      }
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
        ticketData: 'train.ticketData',
        baichuanTrainPrivacy: 'common.baichuanTrainPrivacy',
        isNight: 'train.trainInfo.is_ticket_period',
        isTransfer: 'train.isTransfer'
      }),
      rightsInfo() {
        if (this.isNight && this.isTransfer)
          return this.selectSeatInfo?.[0]?.service_info?.offlineService
            ? [this.selectSeatInfo?.[0]?.service_info?.offlineService]
            : []
        else return this.selectSeatInfo?.[0]?.service_info?.serviceInfoList ?? []
      },
      hasSeatSelected() {
        return this.selectSeatInfo?.every((item) => item && Object.keys(item).length)
      },
    },
    methods: {
      ...store.mapMutations({
        setBaichuanTrainPrivacy: 'common.setBaichuanTrainPrivacy'
      }),
      privacyVerify(val) {
        const isComfirm = val.detail
        this.showPrivacy = false
        if (isComfirm) {
          this.setBaichuanTrainPrivacy({})
        }
      },
      showBaichuanPrivacyDrawer() {
        this.showPrivacy = true
      },
      seatInfoClickReport(data) {
        this.expand = false
        this.triggerEvent('selectSeatRights')
        this.triggerEvent('reportClick')
      },
      openRightsDescDrawer(e) {
        this.triggerEvent('openRightsDescDrawer', e.detail)
      }
    }
  })
</script>

<style scoped lang="stylus"></style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'seat-rights-select-card': './seat-rights-select-card',
      'ts-collapse': '@didi/spring-ui/ts-collapse',
      'Privacy': '@/pages/train-detail/components/privacy',
    }
  }
</script>